<template>
  <div class="sustainables">
    <div class="sustainables_header" :style="{height: headerHeight+'px'}">
      <div class="sustainables_future">Build a sustainable future</div>
    </div>

    <div class="sustainables_about">
      <div>
        <p>Proof of Stake Blockchain is an energy efficient and innovative solution to the future of financial system, which attracts us to continously build infrastures and contribute to it.</p>
      </div>
    </div>

    <div class="sustainables_msg_box">
      <div class="sustainables_msg">
        <h3>Energy consumption</h3>
        <div class="sustainables_msg_system">
          <div class="sustainables_msg_system_text">Triditional banking system</div>
          <div class="sustainables_msg_system_progress">
            <p style="width: 80%;background: url('../../static/images/sustainables/01.png') right center;"><img src="../../static/images/sustainables/ban.png" alt=""></p>
          </div>
        </div>
        <div class="sustainables_msg_system">
          <div class="sustainables_msg_system_text">Bitcoin</div>
          <div class="sustainables_msg_system_progress" style="border-color: #FFB865;">
            <p style="width: 40%;background: url('../../static/images/sustainables/02.png') right center;">
              <img class="sustainables_msg_work_img" style="cursor: pointer;" src="../../static/images/sustainables/work.png" alt="" @click="showWork">
              <span>Bitcoin network consumes less than half the energy consumed by the triditional banking system</span>
              <b>&lt;50%</b>
              <i></i>
            </p>
          </div>
        </div>
        <div class="sustainables_msg_system">
          <div class="sustainables_msg_system_text">Proof of Stake Blockchains</div>
          <div class="sustainables_msg_system_progress" style="border-color: #41AE3B;">
            <p style="width: 6%;background: url('../../static/images/sustainables/03.png') right center;">
              <img src="../../static/images/sustainables/stake.png" alt="">
              <b>&lt;0.01%</b>
            </p>
          </div>
        </div>
        <div class="sustainables_msg_tip">
          <p>PoS blockchains only consume less than 0.01% of the bitcoin network.<br>The low carbon footprint of PoS blockchains means we can build and develop without compromising future sustainability.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headerHeight: 996
    }
  },
  created () {
    if ($(window).width() <= 700) {
      this.headerHeight = 400
    } else {
      this.headerHeight = $(window).height() - 90
    }
    $(window).resize(() => {
      if ($(window).width() <= 700) {
        this.headerHeight = 400
      } else {
        this.headerHeight = $(window).height() - 90
      }
    })
  },
  mounted () {
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    showWork: function () {
      if ($(window).width() <= 700) {
        $('.sustainables_msg_work_img').toogle(200)
      }
    }
  }
}
</script>

<style scoped>
.sustainables{
  background-color: #FFFFFF;
}
.sustainables_header{
  background-color: #171A17;
  position: relative;
}
.sustainables_future{
  width: 100%;
  font-size: 100px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #2E9728;
  text-shadow: 0px 2px 1px #000000;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.sustainables_about{
  background-color: #F5FAF5;
}
.sustainables_about div{
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  padding: 116px 0 106px 0;
  justify-content: center;
}
.sustainables_about div p{
  max-width: 833px;
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
}
.sustainables_msg_box{
  padding: 150px 20px;
  background: #ffffff;
}
.sustainables_msg{
  max-width: 1200px;
  margin: 0 auto;
}
.sustainables_msg h3{
  text-align: center;
  font-size: 56px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A5AAA5;
}
.sustainables_msg_system{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 80px 0;
}
.sustainables_msg_system_text{
  width: 363px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: 1px 1px 3px 0px #D6D6D6;
  border-radius: 45px;
  font-size: 24px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
}
.sustainables_msg_system_progress{
  width: 777px;
  height: 38px;
  background: #FFFFFF;
  border: 4px solid #F97F78;
  border-radius: 20px;
}
.sustainables_msg_system_progress p{
  height: 100%;
  margin: 0;
  background-size: auto 100%;
  border-radius: 20px;
  position: relative;
}
.sustainables_msg_system_progress p b{
  position: absolute;
  width: 75px;
  height: 100px;
  text-align: right;
  line-height: 100px;
  right: -55px;
  top: -125px;
  font-size: 14px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #999999;
  background: url('../../static/images/sustainables/xuxian.png') left top no-repeat;
  background-size: 12px auto;
}
.sustainables_msg_system_progress p:hover span{
   display: block;
}
.sustainables_msg_system_progress p:hover i{
   display: block;
}
.sustainables_msg_system_progress p span{
  position: absolute;
  right: -180px;
  top: -100px;
  width: 387px;
  text-align: center;
  background: #FFFFFF;
  box-shadow: 1px 1px 21px 0px #D6D6D6;
  border-radius: 42px;
  padding: 10px;
  font-size: 14px;
  font-family: 'PingFangSC-Medium';
  font-weight: 400;
  color: #535353;
  z-index: 9;
  display: none;
}
.sustainables_msg_system_progress p i{
    position: absolute;
    right: 6px;
    top: -46px;
    width: 15px;
    height: 15px;
    background: #FFFFFF;
    transform: rotateZ(45deg);
    border: 1px solid #D6D6D6;
    border-top: 0;
    border-left: 0;
    z-index: 10;
    border-radius: 2px;
    display: none;
}
.sustainables_msg_system_progress p img{
  width: 70px;
  height: 70px;
  position: absolute;
  right: -20px;
  top: -20px;
}
.sustainables_msg_tip{
  margin-top: 120px;
}
.sustainables_msg_tip p{
  text-align: center;
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
}
@media (max-width: 1212px) {
  .sustainables_about div{
    display: block;
  }
  .sustainables_about div p{
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  }
  .sustainables_msg{
    max-width: 777px;
    margin: 50px auto;
  }
  .sustainables_msg_system{
    display: block;
    width: 100%;
  }
  .sustainables_msg_system_progress{
     width: 100%;
  }
  .sustainables_msg_system_text{
    width: 100%;
    height: auto;
    text-align: right;
    display: block;
    box-shadow: none;
    margin-bottom: 20px;
    font-size: 20px;
  }
  .sustainables_msg h3{
    font-size: 30px;
  }
  .sustainables_msg_tip p{
    font-size: 18px;
  }
}
@media (max-width: 1200px) {
  .sustainables_future{
    font-size: 65px;
  }
  .sustainables_msg_box{
    padding: 30px 20px;
  }
}
@media (max-width: 960px) {
  .sustainables_future{
    padding: 0 50px;
  }
  .sustainables_msg{
    margin: 20px auto;
  }
  .sustainables_msg h3{
    font-size: 25px;
  }
  .sustainables_msg_tip p{
    font-size: 16px;
  }
}
@media (max-width: 720px) {
  .sustainables_future{
    font-size: 40px;
  }
  .sustainables_about div{
    padding: 40px 20px;
  }
  .sustainables_about div p{
    font-size: 18px;
  }
  .sustainables_msg_system_text{
    font-size: 18px;
  }
  .sustainables_msg_system_progress p span{
    position: absolute;
    right: -244px;
    top: -120px
  }
  .sustainables_msg_system_progress p i{
    position: absolute;
    right: 6px;
    top: -68px
  }
}
@media (max-width: 634px) {
  .sustainables_future{
    font-size: 30px;
  }
  .sustainables_msg_system_text{
    font-size: 16px;
  }
}
@media (max-width: 360px) {
  .sustainables_future{
    padding: 0 20px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable_future.vue